<template>
  <div class="modal fade step-advanced-settings-modal" :id="modalId" tabindex="-1" role="dialog" :aria-labelledby="headerId">
    <div class="modal-dialog modal-lg" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
          <h4 class="modal-title" :id="headerId">Advanced Settings</h4>
        </div>
        <div class="modal-body mb-0">
          <div v-if="loading" class="modal-loading-indicator"></div>
          <step-advanced-settings-form
            v-else
            :campaign-id="campaignId"
            :pieces="pieces"
            :step-id="stepId"
            :show-form-submission-notifications="showFormSubmissionNotifications"
            :form-submission-notifications-title="formSubmissionNotificationsTitle"
            :form-submission-notifications-description="formSubmissionNotificationsDescription"
            :emailable-type="'steps'"
            :emailable-id="stepId"
            :no-results-message="'Since you have no email addresses entered here, we will use the email addresses set in the notifications section of your account.'"
          ></step-advanced-settings-form>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-default" data-dismiss="modal">Continue</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {createCampaignStepPieceIndexesMap} from '../../../../utility/campaign/step/createCampaignStepPieceIndexesMap';
import StepAdvancedSettingsForm from './StepAdvancedSettingsForm';

export default {
  name: 'step-advanced-settings-modal',
  components: {StepAdvancedSettingsForm},
  props: {
    campaignId: {
      type: Number,
      required: true,
    },
    pieces: {
      type: Array,
      required: true,
    },
    stepId: {
      type: Number,
      required: true,
    },
    showFormSubmissionNotifications: {
      type: Boolean,
      required: true,
    },
    formSubmissionNotificationsTitle: {
      type: String,
      required: true,
    },
    formSubmissionNotificationsDescription: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      loading: true,
    };
  },
  computed: {
    modalId() {
      return `step-advanced-settings-modal-${this.stepId}`;
    },
    headerId() {
      return `${this.modalId}-header`;
    },
  },
  methods: {
    loadCodeFlask() {
      if (window.CodeFlask) {
        this.loading = false;
      } else {
        $.getScript('https://d281oufm7mm6g9.cloudfront.net/sk/lib/codeflask/1.4.1/codeflask.min.js', () => (this.loading = false));
      }
    },
  },
  mounted() {
    $(`#${this.modalId}`).on('show.bs.modal', () => this.loadCodeFlask());
  },
};
</script>

<style lang="scss" scoped>
.modal {
  background-color: rgba(#000, 0.5);
}

.modal-loading-indicator {
  background: center / 50px no-repeat url("/wp-content/themes/snappy-theme/assets/images/loading2.gif");
  height: 50px;
  width: 50px;
  margin: 0 auto;
}

button:hover {
  background-color: unset;
}
</style>
